<template>
    <div>
        <div class="card">
            <div class="fl-te-c">
                <h4 class="mb-3">TEAM DETAILS</h4>
                <btn text="Back" @click="$router.push('/cms/team/')" size="sm"/>
            </div>

            <edit-team v-if="details" :initial-data="details" @success="loadDetails"/>
            <p v-else class="text-center p-3">No data available.</p>
        </div>
        <team-social-media :team="id"/>
    </div>
</template>

<script>
import axios from 'secure-axios';
import urls from '@/data/cms-urls';
import EditTeam from './EditTeam';
import TeamSocialMedia from '../team-social-media-map/TeamSocialMedia';

export default {
    name       : 'DetailsPage',
    components : { TeamSocialMedia, EditTeam },
    data () {
        return {
            loading : false,
            details : '',
            id      : this.$route.params.id
        };
    },
    mounted () {
        this.loadDetails();
    },
    methods : {
        async loadDetails () {
            this.loading = true;
            const response = await axios.form(urls.cms.team.details, { id : this.id });
            const json = response.data;
            if (json.error === false) {
                this.details = json.data;
            } else {
                this.$notify('Could not load data, Please try again later', 'Error', {
                    type : 'danger'
                });
            }
            this.loading = false;
        }
    }
};
</script>

<style scoped>

</style>
